"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Number = exports.Hour = void 0;
/**
 *  Helper common functions that can be used in other situations when this class is reuthilzed.
 */
var Hour = /** @class */ (function () {
    function Hour() {
    }
    Hour.durationToInputFormat = function (time) {
        var hours = Math.floor(time);
        var minutes = Math.round((time - hours) * 60);
        return Number.format2digits(hours) + ':' + Number.format2digits(minutes);
    };
    // 03:30 => 3.5
    Hour.inputFormatToDuration = function (inputString) {
        var hour_minute = inputString.split(':');
        var duration = parseInt(hour_minute[0], 0) + (parseInt(hour_minute[1], 0) / 60);
        return duration;
    };
    Hour.durationToHourMinuteString = function (time) {
        var hours = Math.floor(time);
        var minutes = Math.round((time - hours) * 60);
        var isFilled = !!hours || !!minutes;
        return isFilled ?
            hours + 'u' + (minutes > 0 ? ' ' + minutes + 'm' : '') : '-';
    };
    // if we get 12.33344, 2 decimals, we return 12.33
    Hour.durationRound = function (time, decimals) {
        var precision = 10 * decimals;
        // Multiplay by 10, round the rest, divide back by 10
        return Math.round(time * (precision)) / precision;
    };
    Hour.HumanizeTime = function (time) {
        var hours = Math.floor(time);
        var minutes = Math.round((time - hours) * 60);
        var isFilled = !!hours || !!minutes;
        // Fixes the problem with converting 60 minutes into a hour
        if (minutes === 60) {
            minutes = 0;
            hours += 1;
        }
        return isFilled ?
            hours + 'h' + (minutes > 0 ? ' ' + minutes + 'm' : '') : '-';
    };
    return Hour;
}());
exports.Hour = Hour;
var Number = /** @class */ (function () {
    function Number() {
    }
    Number.format2digits = function (number) {
        return number < 10 ? '0' + number : number;
    };
    return Number;
}());
exports.Number = Number;
